import { createSelector, createStateHook } from 'react-sweet-state';
import { store } from '../../index';
import { UIM_CONSENT_CONSENTED, UIM_CONSENT_REQUIRED, UIM_CONSENT_UNKNOWN } from '../../types';
var selectOverallConsentStatus = createSelector(function (state) {
  return state.uiModificationsConsentStatus;
}, function (consentMap) {
  return Object.values(consentMap).includes(UIM_CONSENT_REQUIRED) ? UIM_CONSENT_REQUIRED : UIM_CONSENT_CONSENTED;
});

/*
 * the purpose of this hook is to provide consent status to GIC
 * if any of the apps require consent, return UIM_CONSENT_REQUIRED (fields should be hidden)
 */
export var useUIModificationsConsentStatus = createStateHook(store, {
  selector: selectOverallConsentStatus
});
export var useUIModificationsConsentStatusForApp = createStateHook(store, {
  selector: function selector(state, _ref) {
    var appId = _ref.appId;
    return state.uiModificationsConsentStatus[appId] || UIM_CONSENT_UNKNOWN;
  }
});
export var useUIModificationsConsentStatusForApps = createStateHook(store, {
  selector: function selector(state) {
    return state.uiModificationsConsentStatus;
  }
});